export const CARD_DISCLOSURE__ICON_TESTID = 'card-disclosure--icon';
